export enum IncomingOrderStatus {
  OnTime = "onTime",
  Arrived = "arrived",
  Delayed = "delayed",
}
